import { useEffect } from "react"
import { IsEmpty } from "../../../../utils"
import { IColumnsOrder } from "../components/TableColumns"
import { getLocalStorageValues, setLocalStorageValues, TableLocalStorageKey } from "../helpers"
import { getDefaultTableOrder } from "../helpers/getDefaultTableOrder"
import { useTableContext } from "../provider"

export const useColumnsOrdering = () => {

  const ctx = useTableContext()

  const { tableId, columns } = ctx.props

  useEffect(() => {

    const storedValue = getLocalStorageValues(tableId, TableLocalStorageKey.order) as IColumnsOrder

    if (storedValue && !IsEmpty(storedValue)) {
      ctx.columns.api.setOrder(storedValue)
      return
    }

    const defaultOrder = getDefaultTableOrder(columns)

    setLocalStorageValues(tableId, TableLocalStorageKey.order, defaultOrder)

    ctx.columns.api.setOrder(defaultOrder)
  }, [])

  const onColumnOrderChange = ({ field, targetIndex, oldIndex }) => {
    // TODO use custom fields count
    const shift = 2

    const index = targetIndex - shift
    const oldIndex_ = oldIndex - shift

    const { tableId } = ctx.props

    const order = getLocalStorageValues(tableId, TableLocalStorageKey.order)

    const newOrder = Object
      .keys(order)
      .reduce((result, key) => {
        if (oldIndex_ > index) {
          result[key] = order[key] < index || order[key] > oldIndex_
            ? order[key]
            : order[key] + 1
        } else {
          result[key] = order[key] === index
            ? order[key] - 1
            : order[key]
        }
        if (key === field) {
          result[key] = index
        }
        return result
      }, {})

    setLocalStorageValues(tableId, TableLocalStorageKey.order, newOrder)
  }

  return {
    onColumnOrderChange
  }
}
